import { memo } from 'react';
import { CatButton } from 'components/blocks-components-interactive';
import {
  CatIconArrowBack,
  CatIconArrowForward
} from 'components/blocks-components-icons';

interface PartsNavigationArrowsProps {
  onPrevious: () => void;
  onNext: () => void;
  currentIndex: number;
  totalImages: number;
  shouldShow: boolean;
  isMobile?: boolean;
}

const PartsNavigationArrows = ({
  onPrevious,
  onNext,
  currentIndex,
  totalImages,
  shouldShow,
  isMobile = false
}: PartsNavigationArrowsProps) => {
  if (!shouldShow) return null;

  return (
    <div className="d-flex align-items-center justify-content-between justify-content-md-start mb-3">
      <span className="fw-medium text-dark me-3">
        {currentIndex + 1} / {totalImages}
      </span>
      <div>
        <CatButton
          size="sm"
          hideText
          onClick={onPrevious}
          className="me-2"
          variant="ghost"
          data-testid="back-arrow-button"
        >
          <CatIconArrowBack slot="before" />
        </CatButton>
        <CatButton
          size="sm"
          hideText
          onClick={onNext}
          variant="ghost"
          data-testid="forward-arrow-button"
        >
          <CatIconArrowForward slot="before" />
        </CatButton>
      </div>
    </div>
  );
};

export default memo(PartsNavigationArrows);
